import React, { useState } from 'react';
import DayJSUtils from '@date-io/dayjs';
import {
    DatePicker,
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { InputAdornment, IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '../propTypes';
import FormInput from '../FormInput';
import CalenderIcon from './../../icons/calendar-empty.svg';

function CustomDatePicker({
    handleDateChange,
    title,
    bootstrapIcon,
    pickerProps,
    isTypedKeyboard,
    disabled,
}) {
    // use State to update the date when the onChange event is dispatched
    const [selected, setSelected] = useState(null);

    const openPicker = (e) => {
        !disabled &&
            e.target.parentElement.parentElement.parentElement.nextSibling.nextSibling.children[0].click();
    };

    return (
        <FormInput
            title={title}
            bootstrapIcon={isTypedKeyboard ? '' : bootstrapIcon}
        >
            <MuiPickersUtilsProvider utils={DayJSUtils}>
                {isTypedKeyboard ? (
                    <KeyboardDatePicker
                        disabled={disabled}
                        value={selected}
                        onChange={(date) => {
                            handleDateChange(date);
                            setSelected(date);
                        }}
                        id={title}
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        {...pickerProps}
                        // openPickerIcon={<img src={CalenderIcon} />}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment
                                    position="start"
                                    onClick={openPicker}
                                >
                                    <IconButton>
                                        <img src={CalenderIcon} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                ) : (
                    <DatePicker
                        value={selected}
                        disabled={disabled}
                        onChange={(date) => {
                            handleDateChange(date);
                            setSelected(date);
                        }}
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        {...pickerProps}
                    />
                )}
            </MuiPickersUtilsProvider>
        </FormInput>
    );
}

CustomDatePicker.propTypes = {
    handleDateChange: PropTypes.func,
    title: PropTypes.string,
    bootstrapIcon: PropTypes.string,
    pickerProps: PropTypes.object,
    isTypedKeyboard: PropTypes.bool,
    disabled: PropTypes.bool,
};

CustomDatePicker.defaultProps = {
    handleDateChange: noop,
    title: 'Challenge',
    bootstrapIcon: 'icon-flag',
    pickerProps: {},
    isTypedKeyboard: false,
    disabled: false,
};

export default CustomDatePicker;
